module.exports = __webpack_public_path__ + "static/media/Logo_Redondo_RD_Blackout.3f9ea06b.gif";